// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1BfaZ","item":"PaymentsMobile_item__ApFh6","label":"PaymentsMobile_label__2aNcy","amount":"PaymentsMobile_amount__15dSP"};